export default __webpack_public_path__ + "static/media/27494_KS2_WX1_RUS_Bicycle-6_2_T-1_2018b.52feb9a9.gif";